<template>
  <component
    v-if="resolvedIcon"
    :is="resolvedIcon"
    :size="size"
    :color="color"
    :stroke-width="strokeWidth"
    :class="defaultClass"
    v-bind="$attrs"
  />
</template>

<script>
import { defineComponent, computed } from 'vue';
import * as icons from '@lucide/vue';

export default defineComponent({
  name: 'LucideIcon',
  inheritAttrs: false,

  props: {
    name: { type: String, required: true },
    size: { type: Number, default: 16 },
    color: { type: String, default: 'currentColor' },
    strokeWidth: { type: [Number, String], default: 2 },
    defaultClass: { type: String, default: '' },
  },

  setup(props) {
    const normalize = (n) => {
      if (!n) return '';
      const s = String(n).replace(/[-_\s]+(.)?/g, (_, c) =>
        c ? c.toUpperCase() : '',
      );
      return s.charAt(0).toUpperCase() + s.slice(1);
    };

    const resolvedIcon = computed(() => {
      const key = normalize(props.name);
      return icons[key] || null;
    });

    return { resolvedIcon };
  },
});
</script>
